<div class="p-6">
  <app-table
    [config]="meterQueryResultTable"
    [data]="meterQueryResultData"
    [(selectedElements)]="selectedElements"
  ></app-table>
</div>

